import { parseISO, isValid } from 'date-fns';
import { formatInstant, parseCalendarDate } from './dateTime';
import { normalizeUtcTimestamp } from './utcDateTime';
export function formatSystemMessage(rawMessage: string): string {
  const match = rawMessage.match(/\{\[TIMESTAMP-\s*([^\]]+)\]}/);
  if (!match) return rawMessage;
  const raw = match[1].trim();
  let date: Date;
  if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/.test(raw)) {
    const [month, day, year, hour, minute, second] = raw.match(/\d+/g)!.map(Number);
    const key = `${year}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
    if (!parseCalendarDate(key) || hour > 23 || minute > 59 || second > 59) return rawMessage;
    date = new Date(`${key}T${String(hour).padStart(2,'0')}:${String(minute).padStart(2,'0')}:${String(second).padStart(2,'0')}Z`);
  } else {
    date = parseISO(normalizeUtcTimestamp(raw));
    if (!isValid(date)) return rawMessage;
  }
  const text = rawMessage.replace(/\s*-\s*\{\[TIMESTAMP-[^\]]+\]}/, '');
  return `${text} · ${formatInstant(date, 'EEE, MMM dd, hh:mm a')}`;
}
